import React from "react";
import { Route, Routes } from "react-router-dom";
import LandingPage from "../pages/LandingPage";
import Service from "./resuableComponents/Service";
import About from "./resuableComponents/About";
import WebDesign from "./resuableComponents/servicesReusableComponets/ServicePages/WebDesign";
import MobileAppDev from "./resuableComponents/servicesReusableComponets/ServicePages/MobileAppDev";
import EcomMobileAppDev from "./resuableComponents/servicesReusableComponets/ServicePages/EcomMobileAppDev";
import SeoServices from "./resuableComponents/servicesReusableComponets/ServicePages/SeoServices";
import DigitalMarketing from "./resuableComponents/servicesReusableComponets/ServicePages/DigitalMarketing";
import LogoDesignService from "./resuableComponents/servicesReusableComponets/ServicePages/LogoDesignService";
import ErpDevelopment from "./resuableComponents/servicesReusableComponets/ServicePages/ErpDevelopment";
import CanvasDotsAnimation from "./resuableComponents/CanvasDotsAnimation";
import ContactUs from "./resuableComponents/ContactUs";
const MainRouter = () => {
	return (
		<div>
			<Routes>
				<Route path="/" exact element={<LandingPage />} />
				<Route path="/service" exact element={<Service />} />
				<Route path="/about" exact element={<About />} />
				<Route path="/website-design" exact element={<WebDesign />} />
				<Route path="/web-development-services" exact element={<WebDesign />} />
				<Route
					path="/mobile-app-development"
					exact
					element={<MobileAppDev />}
				/>
				<Route
					path="/e-commerce-mobile-app-development"
					exact
					element={<EcomMobileAppDev />}
				/>
				<Route path="/software-development" exact element={<MobileAppDev />} />
				<Route path="/seo-services" exact element={<SeoServices />} />
				<Route path="/digital-marketing-service" exact element={<DigitalMarketing />} />
				<Route path="/digital-marketing-service" exact element={<DigitalMarketing />} />
				<Route path="/logo-design-service" exact element={<LogoDesignService />} />
				<Route path="/erp-services" exact element={<ErpDevelopment />} />
				<Route path="/dot" exact element={<CanvasDotsAnimation />} />
				<Route path="/contact" exact element={<ContactUs />} />
			</Routes>
		</div>
	);
};

export default MainRouter;
